/** QL-13 — the inline quiz editor. */
export const T = {
  en_GB: {
    questions: "Questions",
    addQuestion: "Add question",
    editQuestion: "Edit question",
    noQuestions: "No questions yet. Add at least one before saving.",
    optionCount: "options",
    maxScore: "max",
    rules: "Pass rules",
    questionsToAsk: "Questions per attempt",
    questionsToAskHelp: "Drawn at random from the bank each attempt.",
    questionsToAskPerCategory: "Questions per category, per attempt",
    questionsToAskPerCategoryHelp: "Drawn at random from EACH category, each attempt.",
    category: "Category",
    minScore: "Score to pass",
    minScoreHelp: "Summed score across the drawn questions.",
    maxAttempts: "Max attempts",
    maxAttemptsHelp: "Blank means unlimited.",
    attemptResetDays: "Attempts reset after (days)",
    attemptResetDaysHelp: "Blank means the counter never resets.",
    unlimited: "Unlimited",
    never: "Never",
    delete: "Delete",
  },
  nb_NO: {
    questions: "Spørsmål",
    addQuestion: "Legg til spørsmål",
    editQuestion: "Rediger spørsmål",
    noQuestions: "Ingen spørsmål ennå. Legg til minst ett før du lagrer.",
    optionCount: "alternativer",
    maxScore: "maks",
    rules: "Beståttregler",
    questionsToAsk: "Spørsmål per forsøk",
    questionsToAskHelp: "Trekkes tilfeldig fra spørsmålsbanken hvert forsøk.",
    questionsToAskPerCategory: "Spørsmål per kategori, per forsøk",
    questionsToAskPerCategoryHelp: "Trekkes tilfeldig fra HVER kategori, hvert forsøk.",
    category: "Kategori",
    minScore: "Poeng for å bestå",
    minScoreHelp: "Sum for de trukne spørsmålene.",
    maxAttempts: "Maks antall forsøk",
    maxAttemptsHelp: "Tomt betyr ubegrenset.",
    attemptResetDays: "Forsøk nullstilles etter (dager)",
    attemptResetDaysHelp: "Tomt betyr at telleren aldri nullstilles.",
    unlimited: "Ubegrenset",
    never: "Aldri",
    delete: "Slett",
  },
} as const;
